"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const landing_woman_webp_1 = __importDefault(require("../../../../assets/images/landing-woman.webp"));
const logo_webp_1 = __importDefault(require("../../../../assets/images/logo.webp"));
const yellow_check_webp_1 = __importDefault(require("../../../../assets/images/yellow_check.webp"));
require("./IntroductionStyles.scss");
const Introduction = () => {
    const checkList = [
        {
            text: 'Negocie de forma direta e transparente',
            icon: yellow_check_webp_1.default,
        },
        {
            text: 'Sem comissões e burocracias de imobiliárias',
            icon: yellow_check_webp_1.default,
        },
        {
            text: 'Maior visibilidade e interessados em potencial',
            icon: yellow_check_webp_1.default,
        },
    ];
    return (react_1.default.createElement("div", { id: "Introduction" },
        react_1.default.createElement("div", { id: "image-effect" },
            react_1.default.createElement("img", { src: landing_woman_webp_1.default, alt: "woman", loading: "lazy" })),
        react_1.default.createElement("div", { className: "content" },
            react_1.default.createElement("div", { className: "left" },
                react_1.default.createElement("span", null, "Rentabilize"),
                react_1.default.createElement("span", null, "seu im\u00F3vel"),
                react_1.default.createElement("hr", null),
                checkList.map(checkItem => (react_1.default.createElement("span", { key: `${checkItem.text}_${Math.random()}` },
                    react_1.default.createElement("img", { src: checkItem.icon, alt: "checkIcon" }),
                    checkItem.text)))),
            react_1.default.createElement("div", { className: "right" },
                react_1.default.createElement("img", { src: logo_webp_1.default, alt: "logo" })))));
};
exports.default = Introduction;
